import {lazy} from 'react';

export const GroupTimelinesLazy = lazy(() => import(/* webpackChunkName: "groupTimelines" */ '.'));
